export default "__VITE_ASSET__hN$cc3$j__"